<div echarts class="chart" [options]="options"></div>
